
import React, { useState } from 'react'
import { Box, Typography, Grid, Button } from '@mui/material'

import siteInspection from '../assets/site-inspection.png';
import modularKitchen from '../assets/modular-kitchen.png';
import cleaning from '../assets/cleaning.png';
import handtool from '../assets/handtool.png';

import heartBlack from '../assets/hand-holding-heart black.svg';
import heartOrange from '../assets/hand-holding-heart orange.svg';

import starOrange from '../assets/star-orange.svg';
import starBlack from '../assets/star-black.svg';

import personOrange from '../assets/person-orange.svg';
import personBlack from '../assets/person-black.svg';

import shieldOrange from '../assets/shield-orange.svg'
import shieldBlack from '../assets/shield-black.svg'

import { getMostConsultedCategories } from '../Apis/CategoriesApis';
import { useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';

const trustedData = [
    {
        label: '100% on time Delivery',
        highlight: false,
        icon: heartBlack,
        icon2: heartOrange
    },
    {
        label: 'Quality Building Materials',
        highlight: false,
        icon: starBlack,
        icon2: starOrange
    },
    {
        label: 'Dedicated Project Managers',
        highlight: false,
        icon: personBlack,
        icon2: personOrange
    },
    {
        label: 'Certified Civil Engineers',
        highlight: false,
        icon: shieldBlack,
        icon2: shieldOrange
    }
];

const Trusted = () => {
    const navigate = useNavigate();
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const [mostChosen, setMostChosen] = useState([]);
    const swiperRef = React.useRef(null);

    const openConsultationForm = () => {
        window.dispatchEvent(
            new CustomEvent('open-consultation-form', {
                detail: { source: 'trusted' }
            })
        )
    }

    React.useEffect(() => {
        getMostConsultedCategories().then(data => {
            if (data && data.status && Array.isArray(data.data)) {
                setMostChosen(data.data);
            }
        });
    }, []);

    const handleServiceClick = (service) => {
        navigate(`/service/${service.id}`, {
            state: {
                categoryId: service.id,
                plans: service.plans,
                options: service.CategoryOptions,
                isOption: service.isOption,
                image: service.image,
                BoxText: service.BoxText,
                name: service.name // Added name as well for good measure
            }
        });
    };
    return (
        <Box>

            {/* ================= Trusted Section ================= */}
            <Box sx={{ py: 6, textAlign: "center", backgroundColor: "#fff" }}>
                <Typography
                    variant="h5"
                    sx={{ fontWeight: 600, mb: 5 }}
                    color='black'
                >
                    Why We’re a Trusted Building <br /> Contractor in Hyderabad
                </Typography>

                <Grid container spacing={3}>
                    {trustedData.map((item, index) => {
                        const isActive = hoveredIndex === index || item.highlight;

                        return (
                            <Grid size={{ xs: 12, sm: 6, md: 3 }} key={index}>
                                <Box
                                    onMouseEnter={() => setHoveredIndex(index)}
                                    onMouseLeave={() => setHoveredIndex(null)}
                                    sx={{
                                        border: '1px solid #eee',
                                        borderRadius: '12px',
                                        p: 3,
                                        height: '100%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-evenly',
                                        gap: '20px',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s ease',
                                        backgroundColor: isActive ? '#ff6a00' : '#F9F9F9',
                                        color: isActive ? '#fff' : '#000',
                                        boxShadow: isActive
                                            ? '0 10px 25px rgba(0,0,0,0.15)'
                                            : 'none'
                                    }}
                                >
                                    <Box
                                        sx={{
                                            width: 70,
                                            height: 70,
                                            borderRadius: '50%',
                                            backgroundColor: '#fff',
                                            border: isActive
                                                ? '1px solid rgba(255,255,255,0.4)'
                                                : '1px solid #ddd',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            flexShrink: 0
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                width: 32,
                                                height: 32,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}
                                        >
                                            <Box
                                                component="img"
                                                src={isActive ? item.icon2 : item.icon}
                                                alt={item.label}
                                                sx={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'contain'
                                                }}
                                            />
                                        </Box>
                                    </Box>


                                    <Typography
                                        sx={{
                                            fontWeight: 500,
                                            textAlign: 'left'
                                        }}
                                    >
                                        {item.label}
                                    </Typography>
                                </Box>
                            </Grid>
                        );
                    })}
                </Grid>

                <Box sx={{ mt: 5 }}>
                    <Button
                        variant="contained"
                        onClick={openConsultationForm}
                        sx={{
                            backgroundColor: '#ff6a00',
                            borderRadius: '8px',
                            px: 4,
                            py: 1.2,
                            textTransform: 'none',
                            fontWeight: 500,
                            '&:hover': {
                                backgroundColor: '#e85f00'
                            }
                        }}
                    >
                        Book free consultation
                    </Button>
                </Box>
            </Box>

            {/* ================= Chosen Services Section ================= */}
            <Box sx={{ py: 4, pb: 8 }}>
                <Typography
                    variant="h5"
                    fontWeight={600}
                    sx={{ color: '#ff6a00', mb: 2 }}
                >
                    Our Most Choosen Services
                </Typography>

                <Box
                    onMouseEnter={() => {
                        if (swiperRef.current && swiperRef.current.swiper) {
                            swiperRef.current.swiper.autoplay.stop();
                        }
                    }}
                    onMouseLeave={() => {
                        if (swiperRef.current && swiperRef.current.swiper) {
                            swiperRef.current.swiper.autoplay.start();
                        }
                    }}
                >
                    <Swiper
                        ref={swiperRef}
                        modules={[Autoplay]}
                        spaceBetween={20}
                        slidesPerView={1.2}
                        speed={3000}
                        autoplay={{
                            delay: 0,
                            disableOnInteraction: false,
                        }}
                        className="swiper-wrapper-linear"
                        loop={mostChosen.length >= 2}
                        breakpoints={{
                            640: { slidesPerView: 2.2 },
                            1024: { slidesPerView: 3.2 },
                            1200: { slidesPerView: 4.2 }
                        }}
                        style={{ paddingBottom: '20px' }}
                    >
                        {mostChosen.map((service, index) => (
                            <SwiperSlide key={index}>
                                <Box
                                    onClick={() => handleServiceClick(service)}
                                    sx={{
                                        width: '100%',
                                        borderRadius: '12px',
                                        backgroundColor: '#fff',
                                        cursor: 'pointer',
                                        border: '1px solid #f0f0f0',
                                        overflow: 'hidden',
                                        '&:hover': {
                                            boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
                                        }
                                    }}
                                >
                                    <Box
                                        component="img"
                                        src={service.image}
                                        alt={service.name}
                                        sx={{
                                            width: '100%',
                                            height: 160,
                                            objectFit: 'cover'
                                        }}
                                    />

                                    <Box
                                        sx={{
                                            px: 1.5,
                                            py: 1.2,
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center'
                                        }}
                                    >
                                        <Box>
                                            <Typography fontSize={13} fontWeight={500} color='black'>
                                                {service.name}
                                            </Typography>
                                        </Box>

                                        <Button
                                            variant="outlined"
                                            size="small"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleServiceClick(service);
                                            }}
                                            sx={{
                                                borderColor: '#ff6a00',
                                                color: '#ff6a00',
                                                textTransform: 'none',
                                                fontSize: 11,
                                                fontWeight: 600,
                                                borderRadius: '8px',
                                                '&:hover': {
                                                    backgroundColor: '#ff6a00',
                                                    color: '#fff'
                                                }
                                            }}
                                        >
                                            Consult Now
                                        </Button>
                                    </Box>
                                </Box>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </Box>
            </Box>

        </Box>
    );
};

export default Trusted;
